import React from 'react';

import { requestGet, } from '../../../../../modules/request'
import { DataTable, Spinner, } from '../../../../Shared/index'
import ScoreColor from '../../modules/score_color';

const headers = [
  {
    name: 'Score',
    attribute: 'score',
    sortAttribute: 'scoreNumber',
    width: '90px',
    isSortable: true,
    noTooltip: true,
    rowSectionClassName: 'center-content',
    headerClassName: 'center-content'
  },
  {
    name: 'No.',
    attribute: 'questionNumber',
    sortAttribute: 'questionNumber',
    width: '90px',
    isSortable: true,
    noTooltip: true,
    rowSectionClassName: 'center-content',
    headerClassName: 'center-content'
  },
  {
    name: 'Instructions',
    attribute: 'instructions',
    sortAttribute: 'instructions',
    width: '480px',
    isSortable: true,
    noTooltip: true,
    rowSectionClassName: 'allow-wrap'
  },
  {
    name: 'Prompt',
    attribute: 'prompt',
    sortAttribute: 'prompt',
    width: '506px',
    isSortable: true,
    noTooltip: true,
    rowSectionClassName: 'allow-wrap'
  },
]

interface QuestionInterface {
  instructions: string;
  prompt: string;
  question_id: number;
  question_number: number;
  question_uid: string;
  score: number;
}

const QuestionReport = ({ match, }) => {
  const [questions, setQuestions] = React.useState<QuestionInterface[]>(null)

  const { params, } = match
  const { unitId, activityId, classroomId, } = params

  React.useEffect(() => {
    requestGet(`/teachers/progress_reports/question_view/classroom/${classroomId}/activity/${activityId}/unit/${unitId}`, (response) => {
      setQuestions(response.data)
    })
  }, [])

  if (!questions) {
    return (<div className="container"><Spinner /></div>)
  }

  const rows = questions.map((question) => {
    const { instructions, prompt, question_id, question_number, score } = question

    return {
      key: question_id,
      id: question_id,
      score: <span className={ScoreColor(score)}>{score ? `${score}%` : 'N/A'}</span>,
      scoreNumber: score,
      questionNumber: question_number,
      instructions,
      prompt
    }
  })

  return (
    <main className="container question-report">
      <DataTable
        defaultSortAttribute='scoreNumber'
        defaultSortDirection='descending'
        headers={headers}
        reportingFormat={true}
        rows={rows}
      />
    </main>
  )
}

export default QuestionReport
